// extracted by mini-css-extract-plugin
module.exports = {"light":"logo-grid_light__BO5KX","dark":"logo-grid_dark__2JTFY","logoImg":"logo-grid_logoImg__GmxRV","lift":"logo-grid_lift__vVP4K"};